module.exports = __webpack_public_path__ + "img/finances-bg-maskex.c4704197.png";